module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_rectangular_fondo_10.cdb8bfb3.png";